export default "__VITE_PUBLIC_ASSET__7e98cc90__"